let activeDb = null;
let activeTeamMapping = null;
let activePoolMaxTeams = 5;
let scoringFlags = {
  readOnly: false,
  round1ScoringLocked: false,
  round2ScoringEnabled: true,
};

export const setTournamentRuntime = (
  db,
  teamMappingService,
  poolMaxTeams = 5,
  flags = {}
) => {
  activeDb = db;
  activeTeamMapping = teamMappingService;
  activePoolMaxTeams = poolMaxTeams;
  scoringFlags = {
    readOnly: Boolean(flags.readOnly),
    round1ScoringLocked: Boolean(flags.round1ScoringLocked),
    // Default enabled unless explicitly set to false (2026 starts locked).
    round2ScoringEnabled: flags.round2ScoringEnabled !== false,
  };
};

export const getActiveDb = () => activeDb;
export const getActiveTeamMapping = () => activeTeamMapping;
export const getActivePoolMaxTeams = () => activePoolMaxTeams;

export const assertRoundWritable = (round) => {
  if (scoringFlags.readOnly) {
    throw new Error("This tournament archive is read-only.");
  }
  const roundNum = parseInt(round, 10);
  if (roundNum === 1 && scoringFlags.round1ScoringLocked) {
    throw new Error("Round 1 scoring is locked.");
  }
  if (roundNum === 2 && scoringFlags.round2ScoringEnabled === false) {
    throw new Error("Round 2 scoring is locked.");
  }
};
